import { locale } from "./local";

/**
 * Formats a number as a percentage with specified decimal places
 * @param value - The number to format as a percentage
 * @param decimalPlaces - Number of decimal places to display (default: 1)
 * @returns Formatted percentage string with % symbol
 */
export const formatPercent = (value: null | number | undefined, decimalPlaces = 1): string => {
	if (value === null || value === undefined) {
		return "--";
	}
	
	return new Intl.NumberFormat(locale, {
		maximumFractionDigits: decimalPlaces,
		minimumFractionDigits: decimalPlaces,
		style: "percent",
	}).format(value);
};

/**
 * Formats a decimal value (0-1) as a percentage with no decimal places
 * @param value - The decimal value to format (0-1 range)
 * @returns Formatted percentage string with % symbol
 */
export const formatPercentWhole = (value: null | number | undefined): string => {
	return formatPercent(value, 0);
};

